import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { SearchPage } from '_types/public-api';

export const servicePagesCacheKey = (agencySlug: string, locale: string, origin: string) => [
  'servicePages',
  agencySlug,
  locale,
  origin,
];

export const useServicePages = (
  agencySlug: string,
  locale: string,
  origin: string,
): UseQueryResult<
  {
    expertiseSlug: string;
    page: SearchPage | null;
  }[],
  Error
> => {
  return useQuery({
    queryKey: servicePagesCacheKey(agencySlug, locale, origin),
    queryFn: () => [], // retrieved SSR
    staleTime: Infinity,
  });
};
